// App Check 관련 오류 판별·문구 (2026-09-16) — 서버에서 App Check 강제(enforce)를 켠 뒤 우리 화면이 토큰을 못 받으면 나온다.
// 강제는 Firebase 콘솔에서 켜며 기본은 꺼짐 — 꺼진 동안에는 이 문구가 나오지 않는다.
export const APP_CHECK_REQUIRED_TEXT = '브라우저 보안 확인에 실패했습니다. 페이지를 새로고침하거나 광고 차단·보안 확장 프로그램을 끄고 다시 시도해 주세요.';

export function isAppCheckError(e) {
    const code = e?.details?.code || '';
    const msg = `${e?.message || ''} ${e?.code || ''}`;
    return code === 'app-check-required' || /app\s*check|appcheck/i.test(msg);
}
